import React, { Component } from 'react';
import i18next from 'i18next';
import { Header, Icon, Grid, Card, Image, } from 'semantic-ui-react';

import './ExternalLinks.scss';

class ExternalLinks extends Component {

    resourcesSections = {
        monitoring: {
            icon: 'chart pie',
            links: [{
                name: 'Loggly',
                href: 'https://paidit.loggly.com/search/',
                image: 'https://www.loggly.com/wp-content/themes/loggly/img/layout/loggly-logo-grey.png',
                description: 'Paidit logs',
                date: '01/10/18'
            }, {
                name: 'Metabase analytics',
                href: 'https://pi-bi.production.paidit.io/',
                image: 'https://www.metabase.com/images/logo.svg',
                description: 'All our business oriented BI data analytics',
                date: '01/10/18'
            },
            {
                name: 'Google analytics',
                href: 'https://analytics.google.com/analytics/web/?pli=1#/home/a132913919w192690324p188386795/',
                image: 'https://www.gstatic.com/analytics-suite/header/suite/v2/ic_analytics.svg',
                description: 'Google analytics events data',
                date: '01/10/18'
            }, {
                name: 'Firebase',
                href: 'https://console.firebase.google.com/project/testproject-557fc/overview',
                image: 'https://www.gstatic.com/devrel-devsite/prod/vbf4f3f66222b8c8c17b31375459c4f918489da36926d67ecaab655b9dc1cf00f/firebase/images/lockup.png',
                description: 'Firebase app analytics',
                date: '01/10/18'
            }, {
                name: 'Apollo Engine',
                href: 'https://engine.apollographql.com/account/gh.paidit-app/services',
                image: 'https://cdn-images-1.medium.com/max/1600/1*JiTff85gB4lKHtAhykBGKQ.png',
                description: 'Our apollo engine tracking dashboards',
                date: '01/10/18'
            }]
        },
        business: {
            icon: 'dollar sign',
            links: [{
                name: 'Hubspot',
                href: 'https://www.hubspot.com/',
                image: 'https://www.hubspot.com/hubfs/HubSpot_Logos/HSLogo_color.svg?t=1538481298418',
                description: 'Our clientel info',
                date: '01/10/18'
            }]
        },
        technicalInfrastructure: {
            icon: 'code',
            links: [{
                name: 'Jira Board',
                href: 'https://paidit-team.atlassian.net/secure/RapidBoard.jspa?rapidView=2&projectKey=PAID',
                image: 'https://deviniti.com/wp-content/uploads/2018/08/logos__JSoft.png',
                description: 'Our main active Jira board',
                date: '01/10/18'
            }, {
                name: 'Confluence',
                href: 'https://paidit-team.atlassian.net/wiki/spaces/PAID/overview',
                image: 'https://deviniti.com/wp-content/uploads/2018/08/logos__Confluence.png',
                description: 'Our confluence designs and specifications',
                date: '01/10/18'
            }, {
                name: 'Bitbucket',
                href: 'https://bitbucket.org/dashboard/projects',
                image: 'https://deviniti.com/wp-content/uploads/2018/09/logos__Bitbucket.png',
                description: 'Our bitbucket repositories',
                date: '01/10/18'
            }, {
                name: 'AWS',
                href: 'https://eu-west-1.console.aws.amazon.com/console/home?region=eu-west-1',
                image: 'https://www.icmanage.com/wp-content/uploads/2018/05/AWS-logo.png',
                description: 'Our hosting services',
                date: '01/10/18'
            }, {
                name: 'NPM',
                href: 'https://www.npmjs.com/~paidit',
                image: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCA3%0D%0AIj4KCTxwYXRoIGZpbGw9IiNDQjM4MzciIGQ9Ik0wLDB2Nmg1djFoNHYtMWg5di02Ii8+Cgk8cGF0%0D%0AaCBmaWxsPSIjRkZGIiBkPSJNMSwxdjRoMnYtM2gxdjNoMXYtNGgxdjVoMnYtNGgxdjJoLTF2MWgy%0D%0Adi00aDF2NGgydi0zaDF2M2gxdi0zaDF2M2gxdi00Ii8+Cjwvc3ZnPgo=',
                description: 'Our private node.js packages',
                date: '25/12/18'
            }, {
                name: 'OneSignal',
                href: 'https://onesignal.com/apps/88b6bc46-2a1b-44fd-9764-c5e924a7bb71',
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZoAAAB7CAMAAAB6t7bCAAAAxlBMVEX////kSklRUVHkSEfkRkVGRkbjQUBNTU3jPj3jQkHjRENOTk68vLzvm5vjOzpJSUnk5OSHh4dbW1v42NhiYmL87OziNzX5397lVVRCQkLobWxubm7xpqX98fHR0dFWVlbt7e32z8/29vakpKTlUVC9vb3mXFv2yMjm5ubnZGPb29uzs7PztLR5eXnpdnXz8/PshYScnJzqenrtjYzwoaDsiIesrKyDg4PJycn0vr7ysbF0dHTiMC6SkpLulJT1wsLhHhw0NDS/mD/8AAARJ0lEQVR4nO1da0OqTBdFZ4ABEkoFRCWvaWpZ2s2s7H3+/596Z4ABZgC1sjydM+tTCgLOcu+99gWSJAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQGBQ8F2Xdf2j30VAmn4tedNcwh1TdN0CEuT23bPPfY1CUiS254ADWkQxIA6QnB4OxYGdEzY7ZGOIChlADBdw2Xv2Nf3z6K3LOXyQunR0ejq2Nf4T6LWRHoxLyEgJqd/7Av912A/aHAHLyE55uj92Nf6b6Fd0nZZTGI5S6HXfgzuxNyXGAINipDzQ3jez5clAOhOKOmfQOVDJhMCTYRT+37cmR8mBkMf1o594X87/Dn6DDNYDZQEN98Kv6l8jhnMDRTcfCfmn2ZGcPO92GyJM6SwiQGKNQIs2cf+An8t2kXMAB0pGhw1l83JUFMKCzhwJDT092BcoJp1pC+fa9Qi/NrzUkP5mY+yPOoX+Gthl/KYAci5zRb/35uOlseNuT7Chf/9mOcttgLbgZPqrR9GwHSU4fw+7KG5d06O5QAkUs/D4yon0ECzQmr+vaWJgkYn1gJQQebkirBTG+WkQLB57O/x98EfZt2ZMiI28D7i4z5E2oaEnnsn+xn0fOxv8tdhk81ozFtsHL1JXsgHmn6PP1TTM9sAOPY3+dvgZvMVp4Lf3xRosRJQRjXyscxm1D72d/nL8JDRACZeYrupbMkw9TWRdTw3QDv2d/m7YGeMBt1hmxjlKuSYBISdmpsZ7EC/oLF2OiW4/JFzdc8DfHaG4p6PNBpWWm5D57jgWAAm5qaH+HdL+5/Xdms11/3GGkKXkHDa5d+uW6qqymffd94UTv7zCE4/+fEGv7xDX7JHaWaAhkwFmiar1kiKmaHV3HM+rbZpNgA+amm0fP4Odvqrt1a1LMtqudpasL/aulEul9UfokYuk5N9kpoxn6E4eHWbiTcDujl6uHJt265d3Q5TygCQHSeccem3+5yzNlcUCKGuazrU0ejwmntWly2VUFAuG4Ylt2Y3ybbfQ80tv7hLSaokdEFlmRqjtdeNRByAki/VuOkbYO4+o4+lH4AmmDSXd/MGghAtD1u2Pn2RQ1ooDLk6iy3n11Dj89Uzx5bcZPm10VgKyprtynpMFtDfJBuVu6y8M3eOptkTBKC2fA/vPLDHcwVqw0PO6U47apmHIbdo4P811PS4aKE9SNI8NiRljtfP3gwdpCjIBEuy7uMkn3FqmaRI2+w4odvQSkFeFGM80uABCwk39YgZw8DxnpqPUaU+rSpjeE8HO982fImaCkeN6Uq1uKKmkMjRVqid4LDTdDGbsWaG84zZgMb289kNWEIPrJq0lwpABxsEHcghF1a1dX32Ui/LAVPyI91+cYIxWx3qdFvxJWombNoIJymj0eZkloPp5OhwTJQDfQubDW92znbBhQUGqmTeXWpAO1Dd+qYaGIrRuQjMpH+5eipb+GX3MIf/GL5CTZ/LGrFjsR1qAENb8ifcygPiemKZQNzXiCXXHG87X9ssaTkizm9AffKZ68/iPDSaTmo5um+GtzjM0QvR715Op10+t/wKNTV25YFiS2u67iS1X2Yqn0CrJXSAUl/asB5N2VZHc7E0G+XlxmOzZOaHG782HhcIOPe53V6/cxsfg9Ww3pg3L693ZP/989ng8WTnEt6cr1arm8zbq0UrSC099WXAHOMr1LyzWQ2JFNTFwUlfWuc1cvDP+5m+jz3amN2H6IhCPGhAyRdjSz1VSbgHWhh6/PuSY5qmM8lGototCsWJM2c2vllBaLkovIZWB6PMKLTza8+TLUv2Oo/4d9OvBjl8tK1OdjfI4nYXdbyb7Hmtk/SHbxZlz6JqQ7W8s26y7SvUtFmrIA7qlRrNOreRg10Wtia6AduIy8rvbQ01uwSIcsiD66QKcBUUaHD/wVFAoAChw8Unf+5oQEcYGk6RRqk49RZG/VnhRdRVA6ehKWpuWh5V2zgBmkr9FlloI9paJbvLeHFnMQGGd518eiZbbBJlWYnE+Ao1XMKJAwnVZ0C3c7ufZHhGir0Yzv59NtiAYfHZsK9ERRnMXAc6/buiEGrekaKZTmNoEtXhMIVTV9EAUm6fx+P3TcnE5CTOMLQatVV4EXxec1pOp0GGdyKx1JAXmJonL7WXHGvv8/+ouST1B3lKt36FmiYbw7G3eUbJr39eMDxTk94j0ojXY48BlG1ng4XBHp/XodlOQE3bgc4mMId3nEmRyl4M9xVAJ54SGQMNJMyFsaZsvRSdiKPmUmV/9GXr4iVDjXX6JDM7ebHDbGFiLc84G8wGZ9VIt3doOP0KNdwvXndjF4d9mx26LZhCaFvtWMYB4POW5xSeDB+vOLX0HeJCQ1QUNF47aBIPWWGfiZKBnT52YsNU9O83laCgF2AaraFqPOavCEdNiyaosieHKZDRKfPUlM9CW7SogamxS1t5qregImNmhUZFk6ivUMOWnQG0Y1dFokhgGmDSjBFKBFLDpG5P8aU7VqIVJzY1E4Di7AX/MKisrij6nY5SIvtZKelJkMJZUIk9ySQlIuhaly25s1hNJR4sNZGRla3qyflqdu3FJsRSQ45peU+DN9WKtsc6rfOUkmzh4Yxq9PIr1LBxntgAze5xUA7DTlpShe+QUE7rM5iIzb7UXKFtM56TxNtVFFJWTW3zGwDEdlJzEtcXwUZBby/AKgkKBg4Anbdzdl+GmptOyIUXie1p3cqlhljVW5e8fgqZT3owzLrf1I00GYelhtoAdiCuU0wNbd2YH6CmrWyTb0sYF3kINZM+u5GUkELMYbb10EZJzfvRS0cPw7I6i7TtMNTMQqPxYkHXf1FzqTGqdH3DzXJBpedMTW/9Uqwpdmj3kovyqdHuJInGGi3r0ArbrZXt1OixuMPUILaogN+hZQYc5rINO98ESc17VfWY2jNmJ5VsMNSERFiD5EhdykX0OnppxbY32Jo4LZitX6FmUiwDHogbyaUG+zqXUtPIyIDijs39/lYDOM93heK05wrlicClnjKl/smLx2YbVjU2nDQ1l5H7Sh/pRM6hJpUHrYLtMpN2ds8vBovF7PyUEjdLH+tz1MyLxfPEx9+X/NFcxso0oIYQmJbYnHguHg9YI3LQIjCxhudwbMYVoDtNz5l8x4QxNe/TQcuzUrajVvP6NeEys82bbifPapLVnVocNTcnrY4sW5Yly+XrQHgfhBrOGZGUk9qD4kb1GGjGqXhADVlBKhawxPZZp1icuZDbEYbF/UwAiKMMkKWml1Azh9rGtzn42Kw41d6fLl4sOWbHonI3Tc1jngXkUGOkMthTjppZJzlJOUqSDkENX6hJokhJ2ZCCcPAXSw3mz6d9Z+Lb2B40LL6Zw1UAKrx7zWXymi3UTCAYNjLAeiYnoepeXMfrRkNzmprQ/ViMhvsYNf0n2uw2jMSFHoKacba8SX0c+YWHlRqWGr1JBFH0AceOfRtlNNuNofBHsHi+c41/9lSD7aCmBJ0sTPN/uc5yekZz0MhtHZaa6OiqrFbrVZn+Dg5BDTd2QZoC8VJjs5FuEU8NLLnJ7TjEey25MtyWKcE7rVgHYGOIo9RWapoQTMhTDbMoOPJjuF5GPZSOaWpC7cwK4Q9Rcx4kUYZ1Nr3s3nRPL846B6NG4ltpV5KP4n7zWPKbiKWGvCnd0ghFqtPcHJu55YbbmlLUE5B6DpHrEbZS86Btq6Dm4S3SYeEKpamZBitrPab3/hA11wHtamJ21+rBqOEb0KNUNRoOXclfmiBNjfIsJV0cktVw/mz7tNOtVtQUmENgxhJhKzXYmW5tcnczXbOo8amG+jlNTUiDwZSpP0JNNyMjDkhNZmyjhzPNeCxjhFdrPUxTg1yiU1Nxhatdb7//CUsGJXc+A2vBWJ/toKbmbB+tXqh8NriSi6yGruQqu/de1IT+zEsV0Q5IDT91QdYk9lclnUwlrZ201bjrmBmAfPx51p9t7T+TG0Ny9bOrA6AnprCVGmkEiW0Xodsx5BZbRQmLJ3TciaEmKkeWu/HOl3nVgB3UJPWPflRDi0pyITUyV8XbF3wj06lJdqINIKpIV2lqSpNkBJ1MPXNGkyk8csAiTc+mncEEVMoStlMzdkoOPxuyjjUAmXVSvdYs+aWGMiyu4zPUdMPyptqhxYLzTl4NrYiaU48zOhrWjHCUN7Ka4MwfvzeBSzoD0dVO4gdAwyVKU5MwSVQ0F2m29jjDIyCgNTlu3JHO3tu+nRrSEIXsIZ5fnaiyE621IXvVp8Xj7GR2Vo7cGY0IuU0BwwsK1Odv8UjuXtT0w610kqr7JNOWqRfQFTlHq/q2qBb3XYvAe7TAFpYpvgDkUk76PtYAmbHcRGUV4dkBGvsoKPIMNo0pNO+gBmtItuIzVgBt5wzibqShktJJnHFS7cxR06eznpZndWRSFjU+QE1UzTTkAba66UC1yvIi+iEETiwSIKTAqnZ2rUwW/E0cJPNj+/251ACSIN7y90c5uwfLrxwAnU2837hpghJqMuXqHdRItVeQetKXf+cAYEZUXTMdgRQ86nX4BnSSxIflr7ewI7MfNaceJRbDwsY3iKJNSE03fQXdnUvDY83fxQEbpFecSiTzqAGvvZynp+x1f3oPYKfmTO6fr9qbiWmS5J4blN5FDc6CIHCW75gOf/xgaiWYZFPndbYjEK26FwtcfmxjKqf3964jkbVnNWDBTHOoK1ofiEL/WzJSYGUbrruQcUrYu5B4nTi6HGogCcTPDvfBHaObMdoIQagg8vCbEmGJlw47qZHskQN15Ly+OqYGABqljfX8musIYGKSnkD2ToFunVqaYXkD6WPUSLP4l6B6Qerab3mybEVG2o+7pqrHFFH3w33m8QwKXpj+0kynLyEoNQrp8T9nHh0Ad8yiJ2g3HJNMkZlO6S6r6Tavr5w87r2ar2wYGzcdQi3UFZM3Oqk7qHqypZIJMhxxZK+eXpVOMGfJ3ClwUSeriZXDoCvR9hqlphOU+9PUBAOE/8WHPH0KzmV59VjlPT4OFt3w7z7eKgdzhY/dbQuSj5xBQIWIqLYJ86mBDnmqwDr7UIc9jSaAPb5at6+KZmYz1zjuZf7PhP3c3iyby0ruHYfdi8HZdavaqb4sLljZGt75ynmX04vZ40m4X9jejycvHgOkJg774QG6qXOdvL2dLYqSl8uL2Wz12bt629mnmmhkINJtOtmmANDNCamDbbLPgjrURPlxETos9WduwNmJSXYUEELSPBlPHAWy5U1lSUzDbWbpBOavfH7QiptlWGzt/f80+GpLsNCoSYJArdLUmfImedOvaHrmA0ET4ffhwrtmuIkKNWr2foDjYJP3rFqo3wVmwNTQkC3Z7Qb/vIDAnW0pbP25uJANq54KPN1wwpC7CeSI8HNcGsn34fzdZmtosL0s5RETDHP8PgRFLlW9jqJ697EayrNP5IffhVr+P6sBEDXmc6aGphTs+RuegZLFCe0fV1/eBovrTlhCM9RP1oq/BVe5phBYQ0ENjQW623b0PxePUT2TVNzocJRh/cxNuPsim3hGzChaktLVch5QF0ApaF7++ZiVab5OSwdy9c9iRpLuMtyQJzqObit393G+7o6GKO95wpk6/y/C6ZlqxSVOQ5XrQUngzwLLDdDRsFmpcUvet2vrZQNxjz/RJr/6Adyni1ZHDeopavV69qeoZgYpboCmL/l7i2P4vbtG+p/cKb+bGYLu9Hx1sppOu8e+kCLQ4gtQSrc7GsnvzViqofnv9Wa/B+3goVoavN/DDHqYnFLwb5++/7oE8HqXNIDme/qnXhNBXREPRf8h+EvlAw9Z6jXEf+P6QYjAISAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBwRPwfN55x7lZjk8EAAAAASUVORK5CYII=',
                description: 'App notifications',
                date: '01/10/18'
            }, {
                name: 'Twilio',
                href: 'https://www.twilio.com/console/sms/logs',
                image: 'https://s3.amazonaws.com/com.twilio.prod.cms-assets/Twilio_logo_red_2.png',
                description: 'SMS management panel',
                date: '01/10/18'
            }, {
                name: 'Plivo',
                href: 'https://console.plivo.com/sms/logs/messages/',
                image: 'https://www.plivo.com/assets/dist/images/primary-logo.svg',
                description: 'The old SMS management panel',
                date: '01/10/18'
            }, {
                name: 'Snyk',
                href: 'https://app.snyk.io/org/paidit',
                image: 'https://dka575ofm4ao0.cloudfront.net/pages-transactional_logos/retina/26274/wT7rVqNYQLWhEByExsiT',
                description: 'Security issue management panel',
                date: '01/10/18'
            }, {
                name: 'Github',
                href: 'https://github.com/paidit-app',
                image: 'https://i0.wp.com/www.inferencelab.com/wp-content/uploads/github-bb449e0ffbacbcb7f9c703db85b1cf0b.png?fit=1125%2C417',
                description: 'Our Github profile page',
                date: '01/10/18'
            }, {
                name: 'Circle CI',
                href: 'https://circleci.com/dashboard',
                image: 'https://assets.brandfolder.com/otz6k5-cj8pew-e4rk9u/view.png?v=1501538594',
                description: 'Our CI platform',
                date: '01/10/18'
            }],
        },
        environments: {
            icon: 'server',
            links: [{
                name: 'Production',
                href: 'https://pi-environment-service.production.paidit.io/graphql?query=query%20all%20%7B%0A%20%20Environment%20%7B%0A%20%20%20%20services%20%7B%0A%20%20%20%20%20%20type%0A%20%20%20%20%20%20name%0A%20%20%20%20%20%20url%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D&operationName=all',
                image: 'https://cdn4.iconfinder.com/data/icons/smashicons-file-types-outline/58/25_-_JSON_File_Outline-512.png',
                description: 'All production services',
                date: '01/10/18'
            }, {
                name: 'Integration',
                href: 'http://ec2-34-241-47-162.eu-west-1.compute.amazonaws.com:10101/graphql?query=query%20all%20%7B%0A%20%20Environment%20%7B%0A%20%20%20%20services%20%7B%0A%20%20%20%20%20%20type%0A%20%20%20%20%20%20name%0A%20%20%20%20%20%20url%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D&operationName=all',
                image: 'https://cdn4.iconfinder.com/data/icons/smashicons-file-types-outline/58/25_-_JSON_File_Outline-512.png',
                description: 'All integration services',
                date: '01/10/18'
            }, {
                name: 'Development',
                href: 'https://pi-environment-service.development.paidit.io/graphql?query=query%20all%20%7B%0A%20%20Environment%20%7B%0A%20%20%20%20services%20%7B%0A%20%20%20%20%20%20type%0A%20%20%20%20%20%20name%0A%20%20%20%20%20%20url%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D&operationName=all',
                image: 'https://cdn4.iconfinder.com/data/icons/smashicons-file-types-outline/58/25_-_JSON_File_Outline-512.png',
                description: 'All EB deployed development services (make sure you are running them locally)',
                date: '25/12/18'
            }]
        },
        techincalResources: {
            icon: 'book',
            links: [{
                name: 'Stackshare',
                href: 'https://stackshare.io/news',
                image: 'https://stackshare.io/assets/stackshare-logo-e6232ef6ee421d60cec8c7c21af4799c40eaaa1be1a80cbe3f2529c9d49b91af.png',
                description: 'Development news based around different stacks',
                date: '01/10/18'
            }, {
                name: 'Medium',
                href: 'https://medium.com/tag/web-development',
                image: 'https://cdn-images-1.medium.com/max/1600/1*TGH72Nnw24QL3iV9IOm4VA.png',
                description: 'Web development articles',
                date: '01/10/18'
            }, {
                name: 'Semantic UI - React',
                href: 'http://react.semantic-ui.com/',
                image: 'https://react.semantic-ui.com/logo.png',
                description: 'The entire React Semantic components wiki',
                date: '01/10/18'
            }, {
                name: 'Knex.js',
                href: 'https://knexjs.org/',
                image: 'https://knexjs.org/assets/images/knex.png',
                description: 'A wiki of the MySQL wrapper module',
                date: '01/10/18'
            }, {
                name: 'Dev.to',
                href: 'https://dev.to/',
                image: 'https://camo.githubusercontent.com/8bbe5211f98dc9849521a6f1fcc332df0d8c2bbf/68747470733a2f2f74686570726163746963616c6465762e73332e616d617a6f6e6177732e636f6d2f692f64336f356c397969716676317a3234636e3179702e706e67',
                description: 'A development blog and articles center for developers by developers',
                date: '25/12/18'
            }, {
                name: 'The Next Web',
                href: 'https://thenextweb.com/dd/#',
                image: 'http://venturecaferotterdam.org/wp-content/uploads/2018/05/TNW_logo_2012-e1525873746438.png',
                description: 'A web development news and coverage website',
                date: '01/10/18'
            }]
        }
    };

    render() {
        return (
            <Grid container relaxed textAlign='center' className='pi-external-links-grid'>
                {
                    Object.keys(this.resourcesSections).map(sectionName => {
                        return [
                            <Grid.Row key={sectionName + '1'} className='pi-external-links-topic'>
                                <Header as='h2' block>
                                    <Icon name={this.resourcesSections[sectionName].icon} />
                                    <Header.Content>{i18next.t(`externalLinks.${sectionName}`)}</Header.Content>
                                </Header>
                            </Grid.Row>,
                            <Grid.Row key={sectionName + "2"}>
                                <Grid.Column>
                                    <Card.Group itemsPerRow={3} size='small' className='pi-external-links-group'>
                                        {
                                            this.resourcesSections[sectionName].links.map(link => (
                                                <Card key={link.name} link raised>
                                                    <div className="pi-external-links-image-container">
                                                        <Image src={link.image} />
                                                    </div>
                                                    <Card.Content>
                                                        <Card.Header>{link.name}</Card.Header>
                                                        <Card.Meta><span className='date'>{link.date}</span></Card.Meta>
                                                        <Card.Description>{link.description}</Card.Description>
                                                    </Card.Content>
                                                    <Card.Content extra>
                                                        <a href={link.href} target="_blank" rel="noopener noreferrer">
                                                            <Icon name='external alternate' />{i18next.t('externalLinks.press')}
                                                        </a>
                                                    </Card.Content>
                                                </Card>
                                            ))
                                        }
                                    </Card.Group>
                                </Grid.Column>
                            </Grid.Row>
                        ];
                    })
                }
            </Grid>
        );
    }
}

ExternalLinks.propTypes = {
    
};

export default ExternalLinks;
